import {IDashboardState, initialDashboardState} from '@app/core/store/state/dashboard.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {DashboardActions, EDashboardActions} from '@app/core/store/actions/dashboard.actions';
import {EScheduleActions, ScheduleActions} from '@app/core/store/actions/schedule.actions';
import {ESickDaysActions, SickDaysActions} from '@app/core/store/actions/sick-days.actions';

export const dashboardReducers = (
	state = initialDashboardState,
	action: DashboardActions | ErrorActions | ScheduleActions | SickDaysActions,
): IDashboardState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		case EDashboardActions.GetNextShifts: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EDashboardActions.GetNextShiftsSuccess: {
			return {
				...state,
				isLoading: false,
				nextShifts: action.shifts,
			};
		}
		case EDashboardActions.GetDashboardActionsCount: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EDashboardActions.GetDashboardActionsCountSuccess: {
			return {
				...state,
				isLoading: false,
				actionsCount: action.data,
			};
		}
		case EDashboardActions.GetDashboardUserSalaryCalculation: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EDashboardActions.GetDashboardUserSalaryCalculationSuccess: {
			return {
				...state,
				isLoading: false,
				userSalaryCalculation: action.salaryCalc,
			};
		}
		case EDashboardActions.GetPunchStatusSuccess: {
			return {
				...state,
				isLoading: false,
				punchStatus: action.data,
			};
		}
		case EDashboardActions.PunchInSuccess: {
			const currentPunchStatus = state.punchStatus;
			currentPunchStatus['shift'] = action.data;
			currentPunchStatus.punched_in = true;

			return {
				...state,
				punchStatus: currentPunchStatus,
			};
		}

		case EDashboardActions.PunchOutSuccess: {
			const currentPunchStatus = state.punchStatus;
			currentPunchStatus.shift = undefined;
			currentPunchStatus.punched_in = false;

			return {
				...state,
				punchStatus: currentPunchStatus,
			};
		}
		case EDashboardActions.GetPunchSettingsSuccess: {
			return {
				...state,
				punchSettings: action.settings,
			};
		}

		case EDashboardActions.GetAvailableShiftsSuccess: {
			return {
				...state,
				availableShifts: action.shifts,
			};
		}
		case EDashboardActions.GetWeatherDataSuccess: {
			return {
				...state,
				weather: action.weather,
			};
		}
		case EScheduleActions.AddShiftStockBidSuccess: {
			return {
				...state,
				availableShifts: state.availableShifts.map(sh => {
					if (sh.id === action.shiftId) {
						sh.bid_on_shift = true;
					}

					return sh;
				}),
			};
		}

		case EScheduleActions.DeleteShiftSuccess: {
			return {
				...state,
				availableShifts: state.availableShifts.filter(s => s.id !== action.shift.id),
				nextShifts: state.nextShifts.filter(s => s.id !== action.shift.id),
			};
		}
		case EScheduleActions.PatchShiftSuccess: {
			return {
				...state,
				availableShifts: state.availableShifts.map(s => s.id === action.shift.id ? action.shift : s),
				nextShifts: state.nextShifts.map(s => s.id === action.shift.id ? action.shift : s),
			};
		}

		case EScheduleActions.RemoveShiftFromStockSuccess: {
			return {
				...state,
				availableShifts: state.availableShifts.filter(s => s.id !== action.shiftId),
			};
		}

		case ESickDaysActions.ApproveSickDaySuccess: {
			return {
				...state,
				nextShifts: state.nextShifts.filter(s => s.id !== action.sickDay.shift.id),
				availableShifts: state.availableShifts.filter(s => s.id !== action.sickDay.shift.id),
			};
		}
		default:
			return state;
	}
};
